import { getQueryParam } from "@scandipwa/scandipwa/src/util/Url";
import React, { PureComponent } from "react";

export class Dimaondshape extends PureComponent {
    static propTypes = {
        value: this.propTypes,
        shape_array: this.propTypes
    };

    componentDidUpdate() {
        const { value } = this.props;
        const elem = document.getElementsByClassName("shape-filter-content");
        const queryfilter = getQueryParam("shape", location || '');

        if (queryfilter) {
            // console.log(queryfilter === value?.code ? "shape-filter-content_isSelected " : "");
        } else {
            if (value.code) {
                if (elem.length > 0) {
                    for (var key in elem) {
                        const elemkey = elem[key];
                        if (elemkey.nodeName === "DIV") {
                            if (elemkey.getAttribute("aria-label") === value.code) {
                                elemkey.classList.add("shape-filter-content_isSelected");
                            } else {
                                elemkey.classList.remove("shape-filter-content_isSelected");
                            }
                        }
                    }
                }
            }
        }
    }

    diamondShapeActive() {
        const { value } = this.props;
        const elem = document.getElementsByClassName("shape-filter-content");

        if (value.code) {
            if (elem.length > 0) {
                for (var key in elem) {
                    const elemkey = elem[key];
                    if (elemkey.nodeName === "DIV") {
                        if (elemkey.getAttribute("aria-label") === value.code) {
                            if (elemkey.classList.value.includes("shape-filter-content_isSelected")) {
                                elemkey.classList.remove("shape-filter-content_isSelected");
                            } else {
                                elemkey.classList.add("shape-filter-content_isSelected");
                            }
                        } else {
                            elemkey.classList.remove("shape-filter-content_isSelected");
                        }
                    }
                }
            }
        }
    }

    render() {
        const { value } = this.props;
        const queryfilter = getQueryParam("shape", location || '');
        // console.log(queryfilter === value?.code ? "shape-filter-content_isSelected " : "");

        return (
            <div
                onClick={() => this.diamondShapeActive()}
                className={(queryfilter === value?.code ? "shape-filter-content_isSelected " : "") + "shape-filter-content"}
                aria-label={value.code}
            >
                <div
                    className='shape-filter-icon-contenet'
                >
                    <img src={value.icon} />
                </div>
                <span className='shape-title'>{value.label}</span>
            </div>
        )
    }
}

export default Dimaondshape;